import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@spothero/ui';
import {spriteStyleProps} from 'common/payment-methods-icons/PaymentMethodsIcons';

export const CardSprite = ({cardType}) => {
    return (
        <Image
            src={`/img/cc-icons/${cardType}.svg`}
            alt={`${cardType} Icon`}
            {...spriteStyleProps}
            marginRight={1.5}
            marginBottom="1.5px"
            whiteSpace="nowrap"
            overflow="hidden"
        />
    );
};

CardSprite.propTypes = {
    cardType: PropTypes.string.isRequired,
};

export default CardSprite;
